import { render, staticRenderFns } from "./Audience.vue?vue&type=template&id=32dc05f7&scoped=true"
import script from "./Audience.vue?vue&type=script&lang=js"
export * from "./Audience.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=32dc05f7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc05f7",
  null
  
)

export default component.exports